import { createFileRoute } from '@tanstack/react-router';
import { OrganisationPage } from '@/features/organisation/organisation-page.js';

export const Route = createFileRoute('/_app/settings/organisation')({
  component: OrganisationPage,
});
